import { AppApi } from './app.models';

export const AppApis = {
  enquiryGuest: {
    method: 'POST',
    url: '/api/v1/enquiry/guest',
    public: true,
  },

  featureFlags: {
    method: 'GET',
    url: '/api/v1/Common/feature-flags',
    public: true,
  },

  addressFinder: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/master/address_finder',
    public: true,
    noLoader: true,
  },

  addressFinderWithId: {
    method: 'GET',
    url: (id: string) => `/api/v1/ext/capstone/public/master/address_finder/${id}`,
    pattern: /^\/api\/v1\/ext\/capstone\/public\/master\/address_finder\/[^/]+$/,
    public: true,
    noLoader: true,
  },

  patientMe: {
    method: 'GET',
    url: '/api/v1/patient/me',
  },

  systemConstants: {
    method: 'GET',
    url: (type: string) => `/api/v1/ext/capstone/public/master/system_constants/${type}`,
    pattern: /^\/api\/v1\/ext\/capstone\/public\/master\/system_constants\/[^/]+$/,
    public: true,
    noLoader: true,
  },

  languages: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/master/languages',
    public: true,
    noLoader: true,
  },

  nationalities: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/master/nationalities',
    public: true,
    noLoader: true,
  },

  countries: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/master/countries',
    public: true,
    noLoader: true,
  },

  states: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/master/states',
    public: true,
    noLoader: true,
  },

  appointmnetType: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/online-booking/GetAppointmentTypes',
    public: true,
    noLoader: true,
  },
  internalCompany: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/online-booking/GetCompanyDetails',
    public: true,
    noLoader: true,
  },
  getProvidersByCompanyId: {
    method: 'GET',
    url: '/api/v1/ext/capstone/public/online-booking/GetProvidersByCompanyId',
    public: true,
    noLoader: false,
  },
  onlineBookingFindNextAvailableSlots: {
    method: 'POST',
    url: '/api/v1/ext/capstone/public/online-booking/find_next_v2',
    public: true,
    noLoader: false,
  },
  onlineCreateAppointement: {
    method: 'POST',
    url: '/api/v1/ext/capstone/public/appointment_group/create',
    public: true,
    noLoader: false,
  },
  createPaymentLink: {
    method: 'POST',
    url: '/api/v1/ext/capstone/public/tyro/payment-links',
    public: true,
    noLoader: false,
  },
} satisfies Record<string, AppApi>;
